var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.73722 13.6381C5.73722 14.8978 4.47002 15.9181 2.90865 15.9181C1.34728 15.9181 0.0800781 14.8978 0.0800781 13.6381C0.0800781 12.3796 1.34728 11.3582 2.90865 11.3582C4.47002 11.3582 5.73722 12.3796 5.73722 13.6381ZM15.9201 11.3582C15.9201 12.6178 14.6529 13.6381 13.0915 13.6381C11.5301 13.6381 10.2629 12.6178 10.2629 11.3582C10.2629 10.0985 11.5301 9.0782 13.0915 9.0782C14.6529 9.0782 15.9201 10.0985 15.9201 11.3582Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7887 11.3585V1.09874H15.9201L15.9201 11.3582L14.7887 11.3585ZM5.73726 2.23872L5.73722 13.6381L4.60583 13.6385V2.23872H5.73726Z",
    fill: "#A1A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60583 2.1301C4.60583 1.84749 4.71001 1.57496 4.89816 1.36537C5.08632 1.15578 5.34503 1.02408 5.62412 0.995821L14.6755 0.0838393C14.8329 0.0679074 14.9918 0.0853798 15.142 0.13513C15.2922 0.18488 15.4304 0.265802 15.5477 0.372678C15.6649 0.479553 15.7587 0.610008 15.8228 0.755627C15.887 0.901247 15.9201 1.0588 15.9201 1.21812V2.2384L4.60583 3.37837V2.1301Z",
    fill: "#A1A1A1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAudio);
export default __webpack_public_path__ + "static/media/new_audio.9129b9d6202d37e2e1944d312e4f0af1.svg";
export { ForwardRef as ReactComponent };